// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"dd31006766--wrapper--6kbeK","text":"dd31006766--text--TP9l3","desktop":"dd31006766--desktop--GtRWx","mobile":"dd31006766--mobile--tAJ4X"};